import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import DialogLocationLogDetail from './DialogLocationLogDetail';
import {
    convertDate,
    convertStartEndDatesForFile,
    copyObjectArray,
    sortArrayByKey,
} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import ReactToPrint from 'react-to-print';
import {CSVLink} from 'react-csv';
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import Config from '../messages';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import DetailIcon from 'material-ui/svg-icons/image/remove-red-eye';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/action/receipt';

/**
 * Class for retrieving and displaying Location Log Summary in a single table
 *
 */
class LocationLogReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            logDetail: null,
            reportName: 'Location Log',
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Location', key: 'location_id'},
                {label: 'Register', key: 'register'},
                {label: 'User', key: 'user'},
                {label: 'Type', key: 'type'},
                {label: 'Open or Close Date', key: 'date_string'}
            ],
            message: null,
            summaryComplete: false,
        };
        this.processData = this.processData.bind(this);
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchData('open');
    }

    componentWillReceiveProps(nextProps) {
        let clearTable = false;
        if (
            nextProps.endDate !== this.props.endDate ||
            nextProps.locationId !== this.props.locationId ||
            nextProps.offset !== this.props.offset ||
            nextProps.startDate !== this.props.startDate
        ) {
            clearTable = true;
        }
        if (clearTable) {
            this.setState({
                summaryList: [],
                summaryTableData: [],
                summaryComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.endDate !== this.props.endDate ||
            prevProps.locationId !== this.props.locationId ||
            prevProps.offset !== this.props.offset ||
            prevProps.startDate !== this.props.startDate
        ) {
            this.fetchData('open');
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get data for Open or Closed Locations
     *
     * @param type
     */
    fetchData(type) {
        // Assemble the URI
        const params = {
            location_id: this.props.locationId,
            start_date: this.props.startDate,
            end_date: this.props.endDate,
            offset: this.props.offset,
            type: type
        };
        const resource = reportsResources.LocationLogById.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                this.processData(type, result.data.payload);
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + this.state.reportName + '.';
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + this.state.reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                summaryList: [],
                summaryTableData: [],
                summaryComplete: false,
            }, () => {
                if (typeof this.props.onError === 'function') {
                    this.props.onError('location', message);
                }
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Store Location and Type results
     *
     * @param type
     * @param data
     */
    processData(type, data) {

        let list = copyObjectArray(this.state.summaryList);

        let dataLength = data.length;
        if (dataLength) {
            for (let i = 0; i < dataLength; i++) {
                let item = data[i];

                let date = (item.date) ? item.date : '(No Date)';
                let dateString = (item.date) ? convertDate(item.date, 'display', true, true, this.props.offset, true) : '(No Date)';

                let row = {
                    date: date,
                    date_string: dateString,
                    device: (item.client && item.client.device) ? item.client.device : '',
                    location_id: (item.location_id) ? item.location_id : '----',
                    register: (item.client && item.client.register) ? item.client.register : '----',
                    signature: (item.signature) ? item.signature : '',
                    source: (item.client && item.client.source) ? item.client.source : '',
                    system: (item.client && item.client.system) ? item.client.system : '',
                    type: (item.type) ? item.type : '',
                    user: (item.client && item.client.user) ? item.client.user : '----',
                    version: (item.client && item.client.version) ? item.client.version : ''
                };
                list.push(row);
            }
        }
        const sortedList = sortArrayByKey(list, 'date', 'DESC');

        // Finalize table data and retrieve additional data if needed
        this.setState({
            summaryList: sortedList,
            summaryTableData: sortedList,
            summaryComplete: true
        }, () => {
            if (type === 'open') {
                this.fetchData('close');
            } else {
                this.props.onSummaryComplete('location', true);
            }
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                summaryTableData: tableData
            });
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /**
     * Handle event to open detail dialog and pass data to it
     */
    handleOpenDialog = (event, row) => {
        this.setState({
            dialogOpen: true,
            logDetail: row
        });
    };

    /**
     * Handle event to close detail dialog
     */
    handleCloseDialog = () => {
        this.setState({
            dialogOpen: false,
            logDetail: null
        });
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            endDate,
            startDate,
            system,
        } = this.props;

        const {
            dialogOpen,
            logDetail,
            summaryList,
            summaryTableData,
            summaryTableHeaders,
            summaryComplete,
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('date', 'DESC');

        const dialogActions = [
            <FlatButton
                label="Close"
                primary={true}
                onClick={this.handleCloseDialog}
            />
        ];

        // ReactTable headers and columns for Table
        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: '',
                        accessor: 'date_string',
                        filterable: false,
                        sortable: false,
                        Cell: props => (
                            <span>
                                <DetailIcon
                                    onClick={(e) => this.handleOpenDialog(e, props.row._original)}
                                    style={tableStyles.tableIconButton}
                                />
                            </span>
                        ),
                        width: 80,
                        styles: tableStyles.left
                    },
                    {
                        Header: '',
                        accessor: 'location_id',
                        style: tableStyles.hide,
                        headerStyle: tableStyles.hide
                    },
                    {
                        Header: 'Register',
                        accessor: 'register',
                    },
                    {
                        Header: 'User',
                        accessor: 'user',
                    },
                    {
                        Header: 'Type',
                        accessor: 'type',
                    },
                    {
                        Header: 'Date',
                        accessor: 'date',
                        Cell: props => (
                            <span>{props.row.date_string}</span>
                        )
                    }
                ]
            }
        ];

        const printColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Location',
                        accessor: 'location_id',
                    },
                    {
                        Header: 'Register',
                        accessor: 'register',
                    },
                    {
                        Header: 'User',
                        accessor: 'user',
                    },
                    {
                        Header: 'Type',
                        accessor: 'type',
                    },
                    {
                        Header: 'Date',
                        accessor: 'date_string',
                    }
                ]
            }
        ];

        return (
            <div>
                {summaryComplete &&
                <div className="reports-table-container">

                    {/* Table Header: Location Log */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Location Log */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={'Location-Log-' + system + '-' + dateString + '.csv'}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export Location Log
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>Location Log</span>
                        </h3>
                    </div>

                    {/* Table: Location Log */}
                    <ReactTable
                        key="table-location-log"
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={10}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortOrFilterChange(e, this.locationLogReactTable)}
                        onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.locationLogReactTable)}
                        ref={(r) => this.locationLogReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped no-print"
                    />
                    <ReactTable
                        key="table-location-log-print"
                        data={summaryTableData}
                        columns={printColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        resizable={false}
                        minRows={1}
                        className="-striped print-only"
                    />

                    {/* Detail Dialog */}
                    <Dialog
                        modal={false}
                        open={dialogOpen}
                        onRequestClose={this.handleCloseDialog}
                        autoScrollBodyContent={true}
                        actions={dialogActions}
                    >
                        <ReactToPrint
                            trigger={() =>
                                <RaisedButton
                                    primary
                                    type="button"
                                    label="Print Log Detail"
                                    className="dialog-btn-print"
                                />
                            }
                            content={() => this.locationPrintRef}
                        />
                        <h3 className="dialog-title">Location Log Detail</h3>
                        <DialogLocationLogDetail
                            data={logDetail}
                            ref={el => (this.locationPrintRef = el)}
                        />
                    </Dialog>
                </div>
                }
            </div>
        )
    }
}

LocationLogReport.propTypes = {
    endDate: PropTypes.string,
    locationId: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDisplayMessage: PropTypes.func,
    onError: PropTypes.func,
    onSummaryComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
};

LocationLogReport.defaultProps = {
    endDate: null,
    locationId: null,
    offset: null,
    startDate: null,
};

export default LocationLogReport;



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationLogReport.js